/**
 * QR App - © 2025 Juan Pablo Marín Del Rincón. Todos los derechos reservados.
 *
 * Este sistema fue desarrollado exclusivamente para Dinámica Juvenil Sfa.
 * Se prohíbe su venta, redistribución, modificación o uso no autorizado,
 * total o parcial, sin consentimiento por escrito del autor.
 *
 * Protegido por la Ley Federal del Derecho de Autor (LFDA), Título VII:
 * - Capítulo I: Infracciones Administrativas
 * - Capítulo II: Delitos
 * - Capítulo III: Sanciones
 *
 * Cualquier uso indebido podrá ser sancionado conforme a la ley.
 * Contacto: jpmarin1999.@gmail.com
 */

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "./theme.css";
import { ClickToComponent } from 'click-to-react-component';
// ✅ IMPORTANTE

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>

    <BrowserRouter>
        <ClickToComponent/>
      {" "}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
